export const dragModePopup = (editor) => {
  const dragModeDiv = document.querySelector("#drag-mode");
  if (dragModeDiv.classList.contains("d-none")) {
    dragModeDiv.classList = "";
    dragModeDiv.innerHTML = "";
  }

  const dragModeCommand = "drag-mode";
  // const isCurrentDragModeAbsolute = editor.Commands.isActive(dragModeCommand);
  const isCurrentDragModeAbsolute = editor.editor.get("dmode") === 'absolute'
  const modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
    <div style="padding-right: 17px;" class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h5">Select Drag Mode</div>&nbsp;
          <button class="btn-close" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <small><strong>Note:</strong> Elements that are already part of the canvas <strong>will not be affected</strong> by changing drag mode. The change will apply only for components added after changing drag mode.</small>
          </div>
         <div id="drag-mode-container">
            <div class="row">
              <div class="col" style="border-right: 1px solid #ccc;">
                <form>
                  <div class="form-check mb-3">
                    <input type="radio" name="select-drag-mode" id="translate-drag-mode" class="form-check-input" value="translate" ${!isCurrentDragModeAbsolute ? "checked" : ""} />
                    <label for="translate-drag-mode" class="form-check-label"><strong>Translate Drag Mode</strong></label>
                    <small>
                      <ul class="list-group">
                        <li class="list-group-item">
                          Translate Mode is enabled by default.
                        </li>
                        <li class="list-group-item">
                          In this mode, the position of the elements is dictated by the <code>transform: translate("X"px, "Y"px)</code> property present in <strong>Extra</strong> tab.
                        </li>
                        <li class="list-group-item">
                          Components <strong>can</strong> be dropped inside other components as normal.
                        </li>
                        <li class="list-group-item">
                          If your design has other elements positioned with the <code>transform: translate</code> property, and you try to drag and drop another component in the canvas, it <strong>will cause</strong> the pre-existing elements using the <code>transform: translate</code> property to shift. This is default behaviour of HTML and <code>transform: translate</code> property.
                        </li>
                      </ul>
                    </small>
                  </div>
                  <div class="form-check mb-3">
                    <input type="radio" name="select-drag-mode" id="absolute-drag-mode" class="form-check-input" value="absolute" ${isCurrentDragModeAbsolute ? "checked" : ""} />
                    <label for="absolute-drag-mode" class="form-check-label"><strong>Absolute Drag Mode</strong></label>
                    <small>
                      <ul class="list-group">
                        <li class="list-group-item">
                          In Absolute mode, the position of the elements is dictated by the following properties present in <strong>General</strong> tab:
                          <ul>
                            <li>
                              <code>position: absolute</code>
                            </li>
                            <li>
                              <code>top: "X"px</code>
                            </li>
                            <li>
                              <code>left: "Y"px</code>
                            </li>
                          </ul>
                        </li>
                        <li class="list-group-item">
                          In this mode, components <strong>cannot</strong> be dropped inside other components as normal. If your design contains <strong>Wrapper</strong> component, any component dropped inside the canvas will be appended to the wrapper, else it is appended to the <strong>body</strong> component.
                        </li>
                        <li class="list-group-item">
                          If your design has other elements positioned with the <code>position: absolute</code> property, and you try to drag and drop another component inside the canvas, then it will <strong>not</strong> cause any shifting for pre-existing components that are using <code>position: absolute</code> property. 
                        </li>
                      </ul>
                    </small>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fade modal-backdrop show"></div>`;

  dragModeDiv.innerHTML = modal;
  
  const closeBtn = document.querySelector("#drag-mode .btn-close");

  closeBtn.addEventListener("click", () => {
    dragModeDiv.className = "d-none";
  });

  const selectDragModeInputs = document.querySelectorAll(`#drag-mode [name="select-drag-mode"]`);
  selectDragModeInputs.forEach(input => {
    input.addEventListener("change", (e) => {
      const selectedValue = input.value;
      if(selectedValue === "absolute") {
        editor.Commands.run(dragModeCommand);
      }
      else if(selectedValue === "translate") {
        editor.Commands.stop(dragModeCommand);
      }
    });
  });
};
